export default "<div fxLayout=\"row\" fxLayoutAlign=\"center center\">\r\n  <p></p>\r\n</div>\r\n"